import { useState, useRef, useEffect } from 'react'
import { useNotifications } from '../contexts/NotificationContext'
import NotificationMenu from './NotificationMenu'
import './NotificationBell.css'

const NotificationBell = () => {
  const { unreadCount } = useNotifications()
  // 'closed' | 'open' | 'closing' : la fermeture reste montée le temps de l’animation
  const [menuPhase, setMenuPhase] = useState('closed')
  const [isHovered, setIsHovered] = useState(false)
  const [shouldAnimate, setShouldAnimate] = useState(false)
  const bellRef = useRef(null)
  const prevUnreadCountRef = useRef(unreadCount)

  useEffect(() => {
    // Animer si le nombre de notifications non lues augmente
    if (unreadCount > prevUnreadCountRef.current && unreadCount > 0) {
      setShouldAnimate(true)
      setTimeout(() => setShouldAnimate(false), 1000)
    }
    prevUnreadCountRef.current = unreadCount
  }, [unreadCount])

  const isOpen = menuPhase !== 'closed'

  return (
    <>
      <button
        ref={bellRef}
        className={`notification-bell ${isHovered || shouldAnimate ? 'animate' : ''}`}
        onClick={() => setMenuPhase((phase) => (phase === 'closed' ? 'open' : 'closing'))}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Notifications"
        aria-expanded={menuPhase === 'open'}
        title="Notifications"
      >
        <svg
          className="bell-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
        </svg>
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>
      {isOpen && (
        <NotificationMenu
          bellRef={bellRef}
          isClosing={menuPhase === 'closing'}
          onRequestClose={() => setMenuPhase((phase) => (phase === 'open' ? 'closing' : phase))}
          onClosed={() => setMenuPhase('closed')}
        />
      )}
    </>
  )
}

export default NotificationBell
